import styled from 'styled-components'
import { useRef } from 'react'

export enum SnackBarType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

function backgroundForSnackbarType(type: SnackBarType): string {
  switch (type) {
    case SnackBarType.Info:
      return 'rgb(255, 255, 255)'
    case SnackBarType.Error:
      return 'rgb(211, 47, 47)'
    case SnackBarType.Warning:
      return 'rgb(245, 124, 0)'
    case SnackBarType.Success:
      return 'rgb(56, 142, 60)'
  }
}

function textColorForSnackbarType(type: SnackBarType): string {
  switch (type) {
    case SnackBarType.Info:
      return 'inherit'
    case SnackBarType.Error:
    case SnackBarType.Warning:
    case SnackBarType.Success:
      return 'white'
  }
}

interface SnackBarBodyProps {
  type: SnackBarType
}
const SnackBarBody = styled.div<SnackBarBodyProps>`
  background-color: ${({ type }) => backgroundForSnackbarType(type)};
  color: ${({ type }) => textColorForSnackbarType(type)};

  padding: 1em;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  text-align: start;
  min-inline-size: 20em;
  z-index: 100;
  max-width: 40em;
  line-height: 1.3em;

  box-shadow: rgb(0 0 0 / 20%) 0 3px 5px -1px, rgb(0 0 0 / 14%) 0 6px 10px 0, rgb(0 0 0 / 12%) 0 1px 18px 0;
`

const SnackbarClose = styled.button`
  margin-inline-start: 1em;
`

interface SnackBarProps {
  message: string
  durationSec?: number
  type?: SnackBarType
  onDismissed?: () => void
}

export const SnackBar: React.FC<SnackBarProps> = ({ message, durationSec = 10, type = SnackBarType.Info, onDismissed }) => {
  const myRef = useRef<HTMLDivElement>(null)
  const closeSnackBar = () => {
    if (myRef.current) {
      myRef.current.style.display = 'none'
    }
    onDismissed?.apply(null)
  }
  setTimeout(closeSnackBar, durationSec * 1000)
  return (
    <SnackBarBody ref={myRef} type={type}>
      <span>{message}</span>
      <SnackbarClose onClick={closeSnackBar}>
        <CloseIcon />
      </SnackbarClose>
    </SnackBarBody>
  )
}

// CloseIcon SVG is styled with font properties
const CloseIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 12 12">
    <path
      fill="currentColor"
      d="M11.73 1.58L7.31 6l4.42 4.42-1.06 1.06-4.42-4.42-4.42 4.42-1.06-1.06L5.19 6 .77 1.58 1.83.52l4.42 4.42L10.67.52z"
      fillRule="evenodd"
    />
  </svg>
)
